
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  onUnmounted,
  ref,
} from "vue";
import { useRouter } from "vue-router";
import { useGlobalStore } from "@/stores/global";
import Edit from "@/javascripts/image/edit";
import MaterialItemMaster from "@/masters/material-item-master";
import ItemMaster from "@/masters/item-master";
import EnterButton from "@/components/EnterButton.vue";
import CancelButton from "@/components/CancelButton.vue";
import Button from "@/components/Button.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Alert from "@/components/Alert.vue";

export default defineComponent({
  name: "Edit",
  components: {
    Button,
    EnterButton,
    CancelButton,
    Header,
    Footer,
    Alert,
  },
  setup() {
    const router = useRouter();
    const toSelect = () => router.push({ name: "select" });
    const toWrite = () => router.push({ name: "write" });
    const reload = () => router.go(0);

    const edit = new Edit();

    const { imageEditor } = useGlobalStore();
    const selectedImage = imageEditor.selectedImage;
    if (!selectedImage) {
      toSelect();
      return;
    }
    let canvasImgSrc = "";
    if (imageEditor.isSelectedImageUploaded()) {
      // アップロード画像を使用する場合
      canvasImgSrc = selectedImage.src as string;
    } else {
      // 選択画像を使用する場合
      canvasImgSrc = "/app/assets/img/base_illust/original/";
      canvasImgSrc += selectedImage.fileName;
    }
    const trimPoint = imageEditor.trimPoint;
    const savedEditData = imageEditor.editData;

    const dataFontSrc = "/app/assets/css/image/icomoon-font.css";

    const decoItems = MaterialItemMaster.records;
    const itemHeroIconMasterRecords = ItemMaster.itemHeroIconMasterRecords;

    // ツールボックスの種別
    const TOOLBOX_TYPE = {
      NONE: "none",
      ADD_ITEM: "add-item", // セレクタのclass名に依存
      SAVE_AND_LOAD: "save-load", // セレクタのclass名に依存
    } as const;
    type ToolboxType = typeof TOOLBOX_TYPE[keyof typeof TOOLBOX_TYPE]; // 'None'|'AddItem'|'SaveAndLoad',

    const toolboxType = ref<ToolboxType>(TOOLBOX_TYPE.NONE);

    onMounted(() => {
      edit.setupEditView();
      edit.setupViewMaterial();
      edit.setupViewText();
      edit.setupViewCommon();
    });

    onBeforeUnmount(() => {
      edit.onBeforeUnmount();
    });

    onUnmounted(() => {});

    function onClickReselectBtn() {
      if (edit.is_saved()) {
        toSelect();
        return;
      }
      edit.showAlertLeave();
    }

    function onClickLeaveOkBtn() {
      imageEditor.resetImage();
      toSelect();
    }

    function onClickLeaveNgBtn() {
      edit.closeAlertLeave();
    }

    function onClickShowSaveBtn() {
      updateCurrentToolboxType(TOOLBOX_TYPE.SAVE_AND_LOAD);
      edit.showToolboxSaveOrLoad();
    }

    function onClickSaveBtn() {
      if (imageEditor.editData) {
        // 保存データがあればアラート
        edit.showAlertSave();
        return;
      }

      saveAndReload();
    }

    function onClickSaveOkBtn() {
      edit.closeAlertSave();
      saveAndReload();
    }

    function onClickSaveNgBtn() {
      edit.closeAlertSave();
    }

    function onClickLoadBtn() {
      if (!edit.is_saved()) {
        edit.showAlertLoad();
        return;
      }

      reload();
    }

    function onClickLoadOkBtn() {
      // edit.barrage_prevent_all();
      reload();
    }

    function onClickLoadNgBtn() {
      edit.closeAlertLoad();
    }

    function onClickAddItemForItem() {
      updateCurrentToolboxType(TOOLBOX_TYPE.ADD_ITEM);
      edit.showToolboxAddItemForItem();
    }

    // function onClickAddItemForText() {
    //   edit.showToolboxAddItemForText();
    // }

    function onClickCompleteBtn() {
      // canvas側の更新
      edit.completeEdit();

      // store側への画像保存
      const completedImage = edit.getCompletedImage();
      imageEditor.completeEditing(completedImage);

      // store側への編集情報保存
      save();

      // 遷移
      toWrite();
    }

    function onClickAddMaterialBtn() {
      Edit.addMaterial();
      closeToolbox();
    }

    function updateCurrentToolboxType(type: ToolboxType) {
      toolboxType.value = type;
    }

    function onClickCloseToolboxBtn() {
      closeToolbox();
    }

    function closeToolbox() {
      edit.closeToolboxByType(toolboxType.value);
      updateCurrentToolboxType(TOOLBOX_TYPE.NONE);
    }

    function addMaterialMono(charCode: string, materialId: number) {
      edit.addMaterialMono(charCode, materialId);
      closeToolbox();
    }

    function addMaterialColor(imageSrc: string, materialId: number) {
      edit.addMaterialColor(imageSrc, materialId);
      closeToolbox();
    }

    function save(): boolean {
      const editData = edit.getEditData();
      if (!editData) {
        return false;
      }
      imageEditor.saveEditData(editData);
      return true;
    }

    function saveAndReload() {
      save();
      reload();
    }

    return {
      toSelect,
      canvasImgSrc,
      trimPoint,
      savedEditData,
      dataFontSrc,
      decoItems,
      addMaterialMono,
      addMaterialColor,
      TOOLBOX_TYPE,
      toolboxType,
      itemHeroIconMasterRecords,
      onClickReselectBtn,
      onClickLeaveOkBtn,
      onClickLeaveNgBtn,
      onClickShowSaveBtn,
      onClickSaveBtn,
      onClickSaveOkBtn,
      onClickSaveNgBtn,
      onClickLoadBtn,
      onClickLoadOkBtn,
      onClickLoadNgBtn,
      onClickAddItemForItem,
      //onClickAddItemForText,
      onClickCompleteBtn,
      onClickAddMaterialBtn,
      onClickCloseToolboxBtn,
    };
  },
});
